import React from 'react'
import { useTheme } from '@mui/material'
import BlockComponent from 'components/Cms/Block'
import DialogHeader from 'redesign/components/molecules/dialog-header'
import { DIALOG_SIZES } from '../../molecules/dialog/constants'
import DrawerModal from '../drawer-modal'
import AnnouncementFooter from './announcement-footer'
import { AnnouncementBody, Content } from './styles'
import type { AnnouncementDialogProps } from './types'
import { useAnnouncementDialog } from './use-announcement-dialog'

const AnnouncementDialog: React.FC<AnnouncementDialogProps> = ({ onClose, open, blocks }) => {
  const { palette } = useTheme()
  const { isSmallScreen, headerTitle, orderedBlocks, buttonDetails } = useAnnouncementDialog({ blocks })

  return (
    <DrawerModal
      showPuller
      isOpen={open}
      onClose={onClose}
      isSmallScreen={isSmallScreen}
      noPadding
      header={<DialogHeader title={headerTitle} onClose={onClose} />}
      dialogSize={DIALOG_SIZES.medium}
      footer={<AnnouncementFooter buttonDetails={buttonDetails} />}
      backgroundColor={palette.background.default}
    >
      <AnnouncementBody>
        <Content>
          {orderedBlocks.map((block) => (
            <BlockComponent block={block} key={block.order} />
          ))}
        </Content>
      </AnnouncementBody>
    </DrawerModal>
  )
}

export default AnnouncementDialog
